<template>
  <div>
    <a-modal
      :visible="visible"
      :closable="false"
      :footer="null"
      :centered="true"
      dialogClass="logout-dialog"
    >
      <div class="logout-content-wrapper">
        <img
          src="~@/assets/images/common/logout-warning-icon.svg"
          alt=""
          class="logout-wraning-icon"
        >
        <div class="logout-wraing">
          <p class="logout-wraning-title">下线通知</p>
          <p class="logout-warning-tip">您的账号在其他设备登录，如果这不是您的操作，请及时修改您的登录密码。</p>
        </div>
      </div>
      <div class="logout-btn-wrapper">
        <a-button
          type="primary"
          class="logout-btn-ok"
          @click="handleOk"
        >我知道了</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { removeStore, getStore } from '@/utils/storage'
import { logout } from '@/api/personal.js'
export default {
  data () {
    return {
      visible: false
    }
  },
  methods: {
    handleShowDialog () {
      console.log("2");
      this.visible = true
      logout({
        outCode: 2
      }).then(() => {
      })
    },
    clearStorage () {
      removeStore('privateAccessToken')
      removeStore('userInfo')
      removeStore('industryId')
      removeStore('menu')
      removeStore('projectInfo')
      removeStore('kbBaseUrl')
      removeStore('allMenuCode')
      removeStore('curEnterpriseInfo')
      removeStore('allPermCode')
      removeStore('appId')
      removeStore('industryId')
    },
    handleOk () {
      this.visible = false
      this.clearStorage()
      sessionStorage.removeItem('subCode')
      let getLinkCode = getStore('setLinkCode')
      if (getLinkCode && getLinkCode !== 'undefined') {
        window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
      } else {
        window.location.reload()
      }
      // window.location.reload()
    }
  }
}
</script>
<style lang="less" scoped>
.logout-content-wrapper {
  display: flex;
  align-items: flex-start;
  .logout-wraing {
    margin-left: 17px;
    &-title {
      font-weight: 500;
      font-size: 16px;
      color: #262626;
      margin-bottom: 10px;
    }
    &-tip {
      color: #8c8c8c;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>